<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card>
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de inicio</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de fin</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button @click="listPreview()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button class="btnx" type="filled" color="danger" @click="downloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <vs-card>
            <h3 class="card-title d-flex">
              Tabla de previsualización
            </h3>
            <div class="border" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table max-items="20" pagination :data="tableData">
                <template slot="thead">
                  <vs-th>Fecha</vs-th>
                  <vs-th>Facturas emitidas</vs-th>
                  <vs-th>Facturado</vs-th>
                  <vs-th>Subtotal</vs-th>
                  <vs-th>Impuesto</vs-th>
                  <vs-th>Pago elctrónico</vs-th>
                  <vs-th>Importe de recaudo</vs-th>
                  <vs-th>Consignación física</vs-th>
                  <vs-th>Diferencia</vs-th>
                  <vs-th>Eventos retornar</vs-th>
                  <vs-th>Retornares</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].days">
                      {{ data[indextr].days }}
                    </vs-td>
                    <vs-td :data="data[indextr].totalBilling">
                      {{ data[indextr].totalBilling }}
                    </vs-td>
                    <vs-td :data="data[indextr].invoiced">
                      {{ data[indextr].invoiced }}
                    </vs-td>
                    <vs-td :data="data[indextr].subtotalInvoiced">
                      {{ data[indextr].subtotalInvoiced }}
                    </vs-td>
                    <vs-td :data="data[indextr].tax">
                      {{ data[indextr].tax }}
                    </vs-td>
                    <vs-td :data="data[indextr].electronic">
                    {{ data[indextr].electronic }}
                  </vs-td>
                    <vs-td :data="data[indextr].collected">
                      {{ data[indextr].collected }}
                    </vs-td>
                    <vs-td :data="data[indextr].registeredDeposit">
                      {{ data[indextr].registeredDeposit }}
                    </vs-td>
                    <vs-td :data="data[indextr].diference">
                      {{ data[indextr].diference }}
                    </vs-td>
                    <vs-td :data="data[indextr].refundsEvents">
                      {{ data[indextr].refundsEvents }}
                    </vs-td>
                    <vs-td :data="data[indextr].refunds">
                      {{ data[indextr].refunds }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-card>
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <vs-card>
              <h3 class="card-title d-flex">
                Totales de la busqueda
              </h3>
              <div class="table-responsive border">
                <table class="table v-middle border">
                  <thead>
                  <tr>
                    <th class=" border-top-0">
                      Facturas emitidas
                    </th>
                    <th class="border-top-0">
                      Total facturado
                    </th>
                    <th class=" border-top-0">
                      Subtotal facturado
                    </th>
                    <th class=" border-top-0">
                      Impuesto IVA
                    </th>
                    <th class=" border-top-0">
                      Pago electrónico
                    </th>
                    <th class=" border-top-0">
                      Importe de recaudo
                    </th>
                    <th class=" border-top-0">
                      Consignación física
                    </th>
                    <th class=" border-top-0">
                      Diferencia
                    </th>
                    <th class=" border-top-0">
                      Eventos retornar
                    </th>
                    <th class=" border-top-0">
                      Valor retornar
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreview.totalBilling }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center" >
                            {{ formatterCurrency(totalsPreview.invoiced) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.subtotalInvoiced) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.tax) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.electronic )}}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{  formatterCurrency(totalsPreview.collected )}}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.registeredDeposit) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{  formatterCurrency(totalsPreview.diference)}}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreview.refundsEvents }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.refunds) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </vs-card>
          </vs-col>
        </vs-col>
        <!-- Fin de tabla de datos -->

      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import CompanySelector from "@/components/Shared/CompanySelector";
import Multiselect from "vue-multiselect";
import centroMayorEndpoint from "@/endpoints/reports/centro-mayor/centroMayorEndpoint";
import DateUtils from "@/global/DateUtils";
import {ROUTES} from "@/global/api_routes";
import toast from "@/global/ToastConfig";
import {formatPrice, formatPriceTwo} from '@/global/utils';

export default {
  components: {
    CompanySelector,
    Multiselect,
  },
  data() {
    return {
      initialDate: null,
      finalDate: null,
      companyId: null,
      isLoading: false,
      showTable: false,
      tableData: [],
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      totalsPreview: {},
    }
  },
  watch:{
    companyId(){
      this.showTable = false;
      this.tableData = [];
      this.totalsPreview={};
    },
    initialDate(){
      this.showTable = false;
      this.tableData = [];
      this.totalsPreview={};
    },
    finalDate(){
      this.showTable = false;
      this.tableData = [];
      this.totalsPreview={};
    },
  },
  methods: {
    /**
     * 
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.showTable = false;
      this.tableData = [];
      this.totalsPreview={};
    },
    /**
     * 
     * @returns {{finalDate: string, companyId: null, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
        }),
      }
    },
    /**
     * Metodo que valida mis parametros en la interfaz grafica
     * para no hecer peticiones erroneas al servidor
     * @returns {Promise<void>}
     */
    async validateForm() { 
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validationResult = await this.$validator.validateAll();
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
      if (!validationResult) {
        throw new Error("Complete el formulario");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
    },
    /**
     *
     * @returns {Promise<void>}
     */
    async downloadReport(){
      try {
        await this.validateForm();
        this.isLoading = true;
        const objParams = this.prepareParameters();
        centroMayorEndpoint.downloadFinanceCollection(objParams)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              let a = document.createElement("a");
              const urlFile =
                  process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
              a.href = urlFile;
              document.body.appendChild(a);
              console.log(urlFile);
              a.download = urlFile;
              a.click();
            })
      }catch (error) {
        toast.error(error);
      }
    },
    /**
     *
     * @returns {Promise<void>}
     */
    async listPreview(){
      try {
        this.isLoading = true;
        const objParams = this.prepareParameters();
        centroMayorEndpoint.listFinanceCollection(objParams)
            .then(data => {
              if (data.info === null) {
                this.tableData = [];
                this.isLoading = false;
                this.showTable=true;
                return;
              }
              this.isLoading = false;
              this.tableData = data.info;
              this.showTable=true;
              this.getTableTotals(data.info);
            });
      }catch (error) {
        toast.error(error);
        this.isLoading = false;
      }
    },
    /**
     * formatea el valor
     * @param value
     * @returns {*}
     */
    formatterCurrency(value) {
      if (isNaN(parseFloat(value))) {
        return formatPriceTwo("0")
      }
      return formatPriceTwo(value);
    },
    /**
     * metodo que quita de un string los signos y los puntos para ser operados matematicamente
     * @param value
     * @returns {*}
     */
    formatStringPrice(value) {
      value = value.replace(/[$.]/g, "").replace(",", ".");
      return value;
    },
    /**
     * metodo que suma los valores de la lista de previsualizacion
     * @param list
     */
    getTableTotals(list) {
      const totals = {};
      list.forEach(value => {
        for (const property in value) {
          if (typeof totals[property] === 'undefined') {
            totals[property] = parseFloat(this.formatStringPrice(value[property])) || 0;
          } else {
            totals[property] += parseFloat(this.formatStringPrice(value[property])) || 0;
          }
        }
      });
      console.log('llegue a table totlas')
      this.prepareObjectTotals(totals)
    },
    prepareObjectTotals(obj) {
      // se eliminan propiedades innecesarias
      var deleteProperties = ["days"];
      for (var property in obj) {
        if (obj.hasOwnProperty(property) && deleteProperties.includes(property)) {
          delete obj[property];
        }
      }
      console.log(obj,'este es el objeto de totales');
      this.totalsPreview =obj;
    }
  }
}
</script>
